import type { IFilterQuery } from "@shared";
import type { IState, IStatePageableResponseData } from "@shared/state";

const ENDPOINT_PREFIX = 'state';

export const useStateStore = defineStore('state', () => {
    const apiClient = useApiClient();
    const states = ref<IState[]>([]);
     const currentState = ref<IState | null| undefined>(null);
     const {getItem, setItem, removeItem} = useLocalStorage();

    const filter = async (payload?: IFilterQuery) => {
        if(!payload) payload = { page: 1, limit: 1000 };
        const result = await apiClient.post<IFilterQuery, IStatePageableResponseData>(ENDPOINT_PREFIX + '/filter', payload);
        if(result.success) states.value = result.data?.data as IState[];
        return result;
    }

    const setCurrentState = async(state?: IState) => {
        currentState.value = state;
        if(!state){
            removeItem(STORE_STATEID_KEY);
        } else {
        setItem(STORE_STATEID_KEY, state);
        }
    };
    
    const prepareCurrentState = async () => {
        const savedState = getItem(STORE_STATEID_KEY);

        if (savedState) {
            currentState.value = savedState;
        }
    };

    return {
        filter,
        states,
        currentState,
        setCurrentState,
        prepareCurrentState
    }
})